import { FuelEntity, FuelFilter } from '../../models'

export const SET_FUELS = 'SET_FUELS'
export const SET_FUELS_LOADED = 'SET_FUELS_LOADED'
export const SET_FUEL_FILTER = 'SET_FUEL_FILTER'
export const SET_SELECTED_FUEL = 'SET_SELECTED_FUEL'

export interface FuelState {
  fuels: FuelEntity[]
  isFuelsLoaded: boolean
  fuelFilter: FuelFilter
  selectedFuel?: FuelEntity
}

interface SetFuelFilterAction {
  type: typeof SET_FUEL_FILTER
  payload: FuelFilter
}

interface SetSelectedFuelAction {
  type: typeof SET_SELECTED_FUEL
  payload?: FuelEntity
}

interface SetFuelsAction {
  type: typeof SET_FUELS
  payload: FuelEntity[]
}

interface SetFuelsLoadedAction {
  type: typeof SET_FUELS_LOADED
  payload: boolean
}

export type FuelAction =
  | SetFuelFilterAction
  | SetSelectedFuelAction
  | SetFuelsAction
  | SetFuelsLoadedAction
